export default __webpack_public_path__ + "static/age-confirm-c29ad78e8d0da9b4491d170596d9395d.png";